import { render, staticRenderFns } from "./sbToyScreen.vue?vue&type=template&id=15012803&scoped=true"
import script from "./sbToyScreen.vue?vue&type=script&lang=ts"
export * from "./sbToyScreen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15012803",
  null
  
)

export default component.exports